module.exports = __webpack_public_path__ + "img/2021-04.f7c22308.jpg";